import lightbox2 from 'lightbox2';

export default function() {


  $(".hi-car").each(function() {
    var items=$(">li", this);
    var current=0;
    var doNext=function() {
      current=(current+1)%items.length;
      items.eq(0).css("margin-left", (-100*current)+"%");
      items.removeClass("active").eq(current).addClass("active");
    }
    setInterval(doNext, 5000);
  });

  $(".nav-toggle").click(function(e) {
    e.preventDefault();
    $(this).closest("header").toggleClass("open");
  });


    lightbox2.option({
//       'resizeDuration': 200,
//       'wrapAround': true
    })

  $("footer .foot-top .totop").click(function(e) {
    e.preventDefault();
    $("html,body").animate({scrollTop: 0}, 300);
  });

  $(".product-catalog .close").click(function(e) {
    e.preventDefault();
    $(".product-catalog").addClass("hidden");

    var now=new Date();
    now.setTime(now.getTime()+1000*1800);

    document.cookie="bPop"+$(this).attr("data-id")+"=1;path=/;expires="+now.toUTCString()+";";
  });
}
